import { Route } from '@angular/router';
import { AuthPath } from '@ipensii/auth/domain-auth';
import { provideDataAccessAuth } from '@ipensii/auth/data-access-auth';
import { smsRedirectGuard } from './guards/sms-redirect-guard';




export const shellAuthRoutes: Array<Route> = [
  {
    path: '',
    children: [
      {
        path: AuthPath.email_confirmation,
        loadChildren: () => import('@ipensii/auth/feature-confirmation').then((m) => m.featureConfirmationRoutes),
      },
      {
        path: AuthPath.identification_redirect,
        loadChildren: () => import('@ipensii/auth/feature-identification').then((m) => m.featureIdentificationRoutes),
      },
      {
        path: AuthPath.password,
        loadChildren: () => import('@ipensii/auth/feature-password-management').then((m) => m.featurePasswordManagementRoutes),
      },
      {
        path: `${AuthPath.url}/:urlShortenerId`,
        children: [],
        canActivate: [smsRedirectGuard],
      }
    ],
    providers: [provideDataAccessAuth()],
  },
];
